import { getAllProductsQuery } from "@framework/utils";
import { normalizeProduct } from "@framework/utils";
import fetcher from '../utils/fetcher'
import type { Product as ShopifyProduct } from '../schema'

async function getAllProducts(options?: any) {
  const { products } = await fetcher({ query: getAllProductsQuery, ...options });
  return {
    products: products.edges.map((edge: Record<string, any>) => {
      const { node } = edge
      return normalizeProduct(node as ShopifyProduct)
    }),
  }
}

export default getAllProducts;
